import { render, staticRenderFns } from "./landing.vue?vue&type=template&id=5fdfb5bc&scoped=true"
import script from "./landing.vue?vue&type=script&lang=js"
export * from "./landing.vue?vue&type=script&lang=js"
import style0 from "./landing.vue?vue&type=style&index=0&id=5fdfb5bc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fdfb5bc",
  null
  
)

export default component.exports